var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsOptional, IsString, IsUUID } from 'class-validator';
export class CreateUserBasicAnamnesisDto {
    userId;
    patientRisk;
    preExistingConditions;
    allergies;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], CreateUserBasicAnamnesisDto.prototype, "userId", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateUserBasicAnamnesisDto.prototype, "patientRisk", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateUserBasicAnamnesisDto.prototype, "preExistingConditions", void 0);
__decorate([
    IsString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateUserBasicAnamnesisDto.prototype, "allergies", void 0);
//# sourceMappingURL=create-user-basic-anamnesis.dto.js.map